import { toUrl } from 'util/link';

// Generate ids for slots
export const getSlotId = (i => (path = '', slots = new Map()) => {
  // Check if this is a "numbered" ad unit, e.g. Collection_001, or a "known" unit
  // like Right_Rail or Footer that we want to be able to target using App Nexus
  const match = path.match(/(\b\w+_\d*|\/Right_Rail|\/Footer|\/Sticky)$/);
  if (match) {
    // Convert to the desired form, e.g. `dfp-collection-001`
    // There will only ever be one of these per page, so it is safe to use the
    // path for the id. Note, we are using this scheme so that App Nexus can
    // use a pre-defined id mapping in their setup.
    // NOTE, we are appening `0` to each id to future proof against any infinite
    // scroll requirements, where multiple 001 units could exist on a page, e.g.
    // multiple posts per page.
    const id = `dfp-${match[0]
      .replace('/', '')
      .replace('_', '-')
      .toLowerCase()}-0`;

    if (slots.has(id) === false) {
      // Slot has not been defined, return the "special" id
      return id;
    }
  }
  return `dfp-${++i}`; // eslint-disable-line
})(0);

// Convert a <template> string into HTML and extract data based on type
export const templateToObj = (type, template) => {
  const parser = new DOMParser();
  // Convert to HTML
  const html = parser.parseFromString(template, 'text/html');
  // Extract data
  switch (type) {
    case 'pusher': {
      const clickUrl = toUrl(html.getElementById('url').href);
      const url = toUrl(clickUrl.searchParams.get('adurl'));
      return {
        pathname: url ? url.pathname : undefined
      };
    }
    default:
      return {};
  }
};
